import {locationContainer, utils} from '@wallaby-ui/core';
import {debounce, find, isEqual} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import HierarchyBox from './HierarchyBox';
import {getHierarchyTypes, loadStateFromParams} from '../hierarchy_actions';
import {getServiceUrls} from 'src/js/containers/filter_and_search/filter_and_search_selectors';
import {changeParamsAndQuery} from 'src/js/containers/filter_and_search/filter_and_search_thunks';

class HierarchyContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    const {filterAndSearchStateId, hierarchyStateId} = this.prop;
    this.debouncedChangeParamsAndQuery = debounce(
      this.props.changeParamsAndQuery,
      500
    ).bind(this);
    this.handleNodeClick = this.handleNodeClick.bind(this);

    this.props.loadStateFromParams(hierarchyStateId, filterAndSearchStateId);
  }

  handleNodeClick(node) {
    if (node && node.getDocumentId()) {
      this.handleDocumentClick(node);
    } else {
      this.handleInnerClick(node);
    }
  }

  handleDocumentClick(node) {
    // do nothing
  }

  handleInnerClick(node) {
    const {
      filterAndSearchStateId,
      locationState,
      parentHierarchyId,
      serviceUrlsBySelector,
    } = this.prop;
    if (node) {
      const oldParentHierarchyId = parentHierarchyId;
      const newParentHierarchyId = node.getId();
      if (!isEqual(oldParentHierarchyId, newParentHierarchyId)) {
        // change hierarchy and reset page
        const params = {
          parentHierarchyId: newParentHierarchyId,
          page: 1,
        };
        // change component state
        this.debouncedChangeParamsAndQuery(
          filterAndSearchStateId,
          serviceUrlsBySelector.searchService,
          params
        );

        // change location state
        this.props.changeParams(
          locationContainer.LOCATION_REDUCER_STATE_ID,
          params,
          locationState.reload,
          false,
          filterAndSearchStateId
        );
      }
    }
  }

  render() {
    const {config, hierarchyComponentStateId, hierarchyId, hierarchyTypes} =
      this.props;
    // hierarchy tree is identified by hierarchyTypeId
    const hierarchyType = find(hierarchyTypes.getItems(), (item) =>
      utils.StringUtils.isEqualNumber(item.getId(), hierarchyId)
    );
    return (
      <HierarchyBox
        config={config}
        hierarchyType={hierarchyType}
        hierarchyComponentStateId={hierarchyComponentStateId}
        onNodeClick={this.handleNodeClick}
      />
    );
  }
}

HierarchyContainer.displayName = 'HierarchyContainer';

/* eslint-disable react/no-unused-prop-types */
HierarchyContainer.propTypes = {
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  filesStateId: PropTypes.string.isRequired,
  filterAndSearchStateId: PropTypes.string.isRequired,
  hierarchyComponentStateId: PropTypes.string.isRequired,
  hierarchyStateId: PropTypes.string.isRequired,
  serviceUrls: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(
  (state, props) => ({
    hierarchyTypes: state[props.hierarchyStateId].hierarchyTypes,
    locationState: state[props.hierarchyStateId].locationState,
    hierarchyId:
      state[props.filterAndSearchStateId].queryParameters.hierarchyId,
    parentHierarchyId:
      state[props.filterAndSearchStateId].queryParameters.parentHierarchyId,
    serviceUrlsBySelector: getServiceUrls(state, props),
  }),
  {
    changeParams: locationContainer.changeParams,
    changeParamsAndQuery,
    getHierarchyTypes,
    loadStateFromParams,
  }
)(HierarchyContainer);
